import snakeCase from 'lodash/snakeCase';
import { Directive, ElementRef, Inject, Input, OnChanges, OnDestroy } from '@angular/core';
import { MapComponent } from './map.component';

export interface IControl {
  position: string;
  element: HTMLElement;
}

@Directive({
  selector: 'map-control',
})
export class MapControlDirective implements OnChanges, OnDestroy {
  @Input() public position;
  private mapPromise: Promise<any>;
  private control: IControl;
  private el: HTMLElement;

  constructor(el: ElementRef, @Inject(MapComponent) private map) {
    this.el = el.nativeElement;
    this.map = map;
  }

  public ngOnChanges(changes) {
    const positionChange = changes['position'];
    if (positionChange.currentValue === positionChange.previousValue) return;
    const promise: Promise<any> = this.mapPromise = this.map.createMapPromise.then(() => {
      if (promise !== this.mapPromise) return;
      this.control = {
        position: snakeCase(positionChange.currentValue).toUpperCase(),
        element: this.el,
      };
      this.map.addControl(this.control);
    });
  }

  public ngOnDestroy() {
    this.map.removeControl(this.control);
  }
}
